export const isCreditNote = invoice => Boolean(invoice?.is_credit_note || invoice?.credit_note_for_invoice_id || Number(invoice?.f_totale) < 0);
export const isIssuedCreditNote = invoice => Boolean(invoice?.credit_note_for_invoice_id || invoice?.credit_note_snapshot);
export const canCreateCreditNote = invoice => Number(invoice?.f_totale) > 0 && invoice?.stato !== 'annullata' && invoice?.remaining_amount !== 0;

export function invoiceState(invoice) {
  if (invoice?.stato === 'annullata') return { status: 'annullata', label: 'Annullata', color: 'default' };
  const credit = isCreditNote(invoice);
  const balance = Number(invoice?.f_totale || 0) - Number(invoice?.f_paga_imp || 0);
  const settled = credit ? balance >= -0.01 : balance <= 0.01;
  if (settled) return { status: 'pagata', label: credit ? 'Regolata' : 'Pagata', color: 'success' };
  if (Math.abs(Number(invoice?.f_paga_imp || 0)) > 0.01) return { status: 'parziale', label: 'Parziale', color: 'info' };
  return { status: 'emessa', label: credit ? 'Credito da regolare' : 'Da Pagare', color: 'warning' };
}
